// removed by extract-text-webpack-plugin
module.exports = {"companyInfo":"companyInfo_companyInfo_3tzlz","item":"companyInfo_item_1B4HT","showDetail":"companyInfo_showDetail_229sm","riskReport":"companyInfo_riskReport_27fdB","valueBox":"companyInfo_valueBox_17zDT","btnBox":"companyInfo_btnBox_2Q4jX","collect":"companyInfo_collect_3kHsQ","imgBox":"companyInfo_imgBox_ECF7L","name":"companyInfo_name_25_6w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/common/companyInfo/companyInfo.scss
// module id = 1536
// module chunks = 0